module.exports = __webpack_public_path__ + "static/media/paypal.e3552f94.png";